<template>
  <div>
    <is-granted v-model="isGranted[0]" :condition="editCondition" display="inline" >
      <el-button type="success" icon="el-icon-edit" @click="startEditBoard" >
        Modifier le Tableau
      </el-button>
      <el-button type="success" icon="el-icon-fa-plus-square" @click="addWidget = true" >
        Ajouter un Widget
      </el-button>
    </is-granted>
    <is-granted v-model="isGranted[1]" :condition="createCondition" display="inline" >
      <el-button type="primary" icon="el-icon-fa-plus-square" @click="addBoard()" >
        Ajouter un Tableau
      </el-button>
    </is-granted>
    <is-granted v-model="isGranted[2]" :condition="editCondition" display="inline" >
      <el-button type="warning" icon="el-icon-fa-eye-slash" @click="archiveBoard" >
        Archiver le Tableau
      </el-button>
      <el-button type="primary" icon="el-icon-fa-eye" @click="unarchiveBoard" >
        Désarchiver un Tableau
      </el-button>
    </is-granted>
    <is-granted v-model="isGranted[3]" :condition="deleteCondition" display="inline" >
      <el-button type="danger" icon="el-icon-fa-trash" @click="deleteBoard" >
        Supprimer le Tableau
      </el-button>
    </is-granted>
    <el-dialog title="Ajouter un Widget" :visible.sync="addWidget" :modal="false" >
      <el-select
         v-model="widgetType"
         popper-class="toolbox-popper"
         placeholder="- Choisir un Widget -"
         value-key="id" >
        <el-option
           v-for="widget in availableWidgets"
           :key="widget.id"
           :label="widget.label"
           :value="widget" >
        </el-option>
      </el-select>
      <el-button
         type="success"
         icon="el-icon-fa-plus-square"
         @click="addNewWidget()"
         :disabled="widgetType === null" >
        Ajouter
      </el-button>
    </el-dialog>
    <el-dialog title="Désarchiver un Tableau" :visible.sync="unarchiveBoardModal" :modal="false" >
      <div v-loading="archivedLoading" >
        <el-select
           v-model="toUnarchiveBoard"
           popper-class="toolbox-popper"
           placeholder="- Choisir un Tableau à désarchiver -"
           value-key="id" >
          <el-option v-for="b in archivedBoards" :key="b.id" :label="b.name" :value="b" >
          </el-option>
        </el-select>
        <el-button
           type="success"
           icon="el-icon-fa-eye"
           @click="unarchiveBoardConfirm"
           :disabled="!toUnarchiveBoard" >
          Désarchiver
        </el-button>
      </div>
    </el-dialog>
    <el-dialog title="Modifier le Tableau" :visible.sync="editBoardModal" :modal="false" >
      <el-form v-loading="editBoardModalLoading">
        <el-form-item label="Titre" >
          <el-input v-model="boardTitle" ></el-input>
        </el-form-item>
        <el-form-item label="Autoriser le filtrage par graphique" >
          <el-checkbox v-model="allowFilterByGraph" />
        </el-form-item>
        <el-form-item label="Filtres Globaux" >
          <el-checkbox v-model="boardHeader" />
        </el-form-item>
        <el-form-item v-if="allowSecondaryBoards" :label="secondaryBoardText" >
          <el-checkbox v-model="boardSecondary" />
        </el-form-item>
        <el-form-item>
          <el-button type="success" @click="editBoard" >Valider</el-button>
          <el-button type="warning" @click="cancelEditBoard" >Annuler</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<style scoped>
.el-form-item .el-select {
    width: 100%;
}
.is-granted {
    margin-right: 10px;
}
</style>

<style>
.toolbox-popper {
    z-index: 2014 !important;
}
</style>

<script>
import {api, IsGranted} from 'macarons'

export default {
  components: {
    IsGranted
  },
  props: {
    value: {
      type: Boolean,
      required: false
    }
  },
  data () {
    return {
      canChangeRoles: false,
      addWidget: false,
      widgetType: null,
      unarchiveBoardModal: false,
      archivedLoading: false,
      archivedBoards: [],
      toUnarchiveBoard: null,
      editBoardModal: false,
      editBoardModalLoading: true,
      boardHeader: null,
      boardTitle: null,
      boardSecondary: false,
      allowFilterByGraph: false,
      isGranted: [false, false, false, false]
    }
  },
  watch: {
    isGranted () {
      this.$emit('input', !this.isGranted.some(g => g))
    }
  },
  computed: {
    allowSecondaryBoards () {
      return !!window[window.macarons].allowSecondaryBoards
    },
    secondaryBoardText () {
      return window[window.macarons].secondaryBoardText || window[window.macarons].secondaryBoardSwitchText || 'Mode cumul'
    },
    editCondition () {
      return {
        attribute: 'UPDATE',
        subject: {
          type: 'entity',
          classname: 'AppBundle\\Entity\\Macarons\\Board',
          id: this.board.id
        }
      }
    },
    createCondition () {
      return {
        attribute: 'CREATE',
        subject: 'AppBundle\\Entity\\Macarons\\Board'
      }
    },
    deleteCondition () {
      return {
        attribute: 'DELETE',
        subject: {
          type: 'entity',
          classname: 'AppBundle\\Entity\\Macarons\\Board',
          id: this.board.id
        }
      }
    },
    availableWidgets () {
      return this.$store.state.widgets.filter(w => w.id !== 'custom_graph_global_filters')
    },
    baseWidgetWidth () {
      return this.$store.getters.getMacarons('baseWidgetWidth')
    },
    baseWidgetHeight () {
      return this.$store.getters.getMacarons('baseWidgetHeight')
    },
    board () {
      return this.$store.state.board
    },
    user () {
      return this.$store.state.user.id
    }
  },
  mounted () {
    this.$watch('board', () => {
      this.boardTitle = this.board.name
    })
  },
  methods: {
    startEditBoard () {
      this.editBoardModal = true
      this.editBoardModalLoading = true
      api.get('board/' + this.board.id).then(({data}) => {
        this.boardTitle = this.board.name
        this.boardHeader = !!data.headerWidget
        this.boardHeaderId = data.headerWidget ? data.headerWidget.id : 0
        this.allowFilterByGraph = data.allowFilterByGraph || false
        this.boardSecondary = data.boardSecondary || false
      }).then(() => {
        this.editBoardModalLoading = false
      })
    },
    editBoard () {
      this.$store.dispatch('updateBoard', {
        name: this.boardTitle,
        headerWidget: this.boardHeader ? this.boardHeaderId : null,
        allowFilterByGraph: this.allowFilterByGraph,
        secondary: this.boardSecondary
      })
      this.editBoardModal = false
    },
    cancelEditBoard () {
      this.boardTitle = this.board.name
      this.editBoardModal = false
    },
    archiveBoard () {
      this.$store.dispatch('archiveBoard').then(() => {
        this.$emit('reload')
        this.$router.push('/home')
      })
    },
    deleteBoard () {
      this.loading = true
      this.$confirm('Ce tableau sera supprimé de manière définitive.', 'Confirmer la suppression', {
        confirmButtonText: 'Supprimer',
        cancelButtonText: 'Annuler',
        type: 'warning'
      }).then(() => {
        this.$store.dispatch('deleteBoard').then(() => {
          this.$emit('reload')
          this.$router.push('/home')
        }).catch(() => {
          this.$message.error('Impossible de supprimer le tableau. Vérifiez qu\'il n\'est pas utilisé comme tableau par défaut dans un espace de travail')
        })
      })
    },
    addNewWidget () {
      this.addWidget = false
      this.$emit('newWidget', {
        x: 0,
        y: 0,
        w: typeof this.widgetType.w === 'undefined' ? this.baseWidgetWidth : this.widgetType.w,
        h: typeof this.widgetType.h === 'undefined' ? this.baseWidgetHeight : this.widgetType.h,
        widget: this.widgetType.component,
        options: typeof this.widgetType.options === 'object' ? this.widgetType.options : {},
        id: this.widgetType.id
      })
    },
    unarchiveBoard () {
      this.archivedLoading = true
      this.unarchiveBoardModal = true
      this.$store.dispatch('archivedBoards').then(response => {
        this.archivedBoards.splice(0, this.archivedBoards.length, ...response.data.boards)
        this.archivedLoading = false
      })
    },
    unarchiveBoardConfirm () {
      this.$store.dispatch('unarchiveBoard', this.toUnarchiveBoard).then(() => {
        this.unarchiveBoardModal = false
        this.$emit('reload')
      })
    },
    addBoard () {
      this.$store.dispatch('addBoard').then(() => {
        this.$emit('reload')
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/macarons/PortalToolbox.vue